export default __webpack_public_path__ + "static/media/empty-due-projects-img.601d00ec.svg";